import { render } from "./SocialAdmin.vue?vue&type=template&id=113ae4be"
import script from "./SocialAdmin.vue?vue&type=script&lang=js"
export * from "./SocialAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__